import { useNavigate } from "react-router";
import Closemodal from "icons/Closemodal";
import SignIcon from "icons/SignIcon";

interface SignInProps {
  setShowSignupPopUp: Function;
}

export const SignIn = (props: SignInProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="peer fixed top-0 left-0 w-full h-full bg-black/70 backdrop-blur-md z-999 flex px-5 items-center justify-center">
        <div className="bg-white w-full sm:max-w-458px sm:min-w-458px px-5 py-8  rounded-xl z-50 text-center space-y-3 relative">
          <Closemodal
            className="w-4 h-4 fill-black absolute right-5 top-5 opacity-50 hover:rotate-90 duration-300 transition"
            setClosePopUp={props.setShowSignupPopUp}
          />
          <div className="bg-lightgray w-16 h-16 rounded-full flex items-center justify-center mx-auto">
            <SignIcon className="w-9 h-9 fill-black" />
          </div>
          <h5 className="text-2xl font-semibold text-black"> It's more fun when you're in!</h5>
          <div
            className="flex items-center justify-center gap-4 !mt-5"
            onClick={() => {
              navigate("/login");
            }}
          >
            <button className="text-base max-w-48 w-full font-semibold text-black hover:bg-opacity-80 transition-all duration-300 rounded-full bg-skyblue border border-skyblue px-8 py-2.5">
              Log In
            </button>
          </div>
          
          <div
            className="flex items-center justify-center gap-4 !mt-5"
            onClick={() => {
              navigate("/register");
            }}
          >
            <button className="text-base max-w-48 w-full font-semibold text-black hover:bg-opacity-80 rounded-full transition-all duration-300  bg-skyblue border border-skyblue px-8 py-2.5">
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
